export const errorMessages = {
	NETWORK_ERROR:
		'Your network connection is down. Please move to a location with a network connection and try again.',
	F5_BLOCK:
		'The action performed produced an error. If the issue persists please reach out to your Account Executive. Your F5 support ID is:',
};
